import React from 'react';

const Footer = () => {
    return (
        <footer className="footer-thin">
            <p>&copy; 2025 Synapse Tutors. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
